module.exports = __webpack_public_path__ + "img/lipstick(4).21dc6f39.png";